export const getBaseUrl = () => {
  return import.meta.env.VITE_APP_URL || window.location.origin;
};

export const getBasename = () => {
  // Use VITE_ROUTER_BASENAME if available, otherwise determine from build mode
  if (import.meta.env.VITE_ROUTER_BASENAME) {
    return import.meta.env.VITE_ROUTER_BASENAME;
  }
  
  // Determine basename based on build mode
  const buildMode = import.meta.env.VITE_BUILD_MODE || 'development';
  if (buildMode === 'staging') {
    return '/sossiety';
  }
  
  return '/';
};

export const getFullUrl = (path: string) => {
  const baseUrl = getBaseUrl().replace(/\/+$/, '');
  const basename = getBasename().replace(/^\/+|\/+$/g, '');
  const cleanPath = path.replace(/^\/+/, '');

  // Check if baseUrl already ends with basename
  if (baseUrl.endsWith(basename)) {
    return `${baseUrl}/${cleanPath}`;
  }

  return basename
    ? `${baseUrl}/${basename}/${cleanPath}`
    : `${baseUrl}/${cleanPath}`;
};

export const getResetPasswordUrl = () => {
  return getFullUrl('/reset-password');
};

export const getAuthCallbackUrl = () => {
  return getFullUrl('/auth/callback');
}; 